import {useClient, useDictionary} from '@adamlip/okeoke.client';
import NumberFlow from '@number-flow/react';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import useBasket from 'hooks/useBasket';

export default function Footer({goToNext}) {
	const {orderItems} = useBasket();
	const {appParams} = useClient;
	const {getValue} = useDictionary();
	const {paymentsNeeded} = useBasket();

	return (
		<div className={` ${appParams?.buttons?.['basketModal']?.containerClass || ''} px-2`}>
			<BarSoftButton buttonName={'basketModal'} isDisabled={orderItems?.filter((item) => item?.count > 0)?.length === 0} size='lg' fullWidth color='primary' className={`${appParams?.styles?.fonts?.capitalize ? 'font-extrabold uppercase' : ''} `} onPress={goToNext}>
				<div className='flex items-center gap-1 font-bold'>
					{`${getValue('app_v2_basket_slider_order_btn')}`}
					<span>
						- <NumberFlow value={paymentsNeeded} suffix=' Ft' />
					</span>
				</div>
			</BarSoftButton>
		</div>
	);
}
